import { GridStack as GridStackBase } from "gridstack";
import { Utils } from "gridstack/dist/utils.js";
import gridstackStylesA from "gridstack/dist/gridstack.min.css?inline";
import gridstackStylesB from "gridstack/dist/gridstack-extra.min.css?inline";
export const styles = gridstackStylesA + gridstackStylesB;

class GridStack extends GridStackBase {
    // Having to override this because otherwise it'll return the wrong,
    // non-overriden GridStack.
    static init(options = {}, elOrString = ".grid-stack") {
        let el = GridStack.getGridElement(elOrString);
        if (!el) {
            if (typeof elOrString === "string") {
                console.error(`No grid was found with ${elOrString}`);
            } else {
                console.error("GridStack.init() no grid element was passed.");
            }
            return null;
        }
        if (!el.gridstack) {
            el.gridstack = new GridStack(el, Utils.cloneDeep(options));
        }

        return el.gridstack;
    }

    // Similar issue as https://github.com/gridstack/gridstack.js/pull/2558,
    // but still need to submit a merge request for this one.
    // https://gitlab.com/stekz/mystekz/frontend/-/issues/341
    _setupRemoveDrop() {
        if (!this.opts.staticGrid && typeof this.opts.removable === "string") {
            // Changed the following line so it makes use of the rootNode instead
            // of the document so it can select item within the shadow dom.
            let trashEl = this.el
                .getRootNode()
                .querySelector(this.opts.removable);
            if (!trashEl) return this;
            // only register ONE drop-over/dropout callback for the 'trash', and it will
            // update the passed in item and parent grid because the 'trash' is a shared resource anyway,
            // and Native DD only has 1 event CB (having a list and technically a per grid removableOptions complicates things greatly)
            const dd = GridStack.getDD();
            if (!dd.isDroppable(trashEl)) {
                dd.droppable(trashEl, this.opts.removableOptions)
                    .on(trashEl, "dropover", (event, el) =>
                        this._itemRemoving(el, true)
                    )
                    .on(trashEl, "dropout", (event, el) =>
                        this._itemRemoving(el, false)
                    );
            }
        }
        return this;
    }

    // Until https://github.com/gridstack/gridstack.js/pull/2558 is merged and
    // a new version is published.
    _removeStylesheet() {
        if (this._styles) {
            const parent = this.opts.styleInHead
                ? undefined
                : this.el.parentNode;
            const id = this._styleSheetClass;
            const target = parent || document;
            let el = target.querySelector("STYLE[gs-style-id=" + id + "]");
            if (el && el.parentNode) el.remove();
            delete this._styles;
        }
        return this;
    }
}

export { GridStack };
